import styled from 'styled-components';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Input } from 'antd';
import Panel from 'common/panel';
import Carousel from 'common/carousel/carousel';
import { Div, Flex, NoteTitle, NoteName, NoteText } from 'ui';
import { types } from 'utils/mappings';
import { sanitize } from '../../../utils/helpers';

const TextAreaWrapper = styled(Div)`
  margin: 0 2px;
  height: 100%;

  > textarea {
    height: ${p => p.small ? '100px' : '180px'} !important;
  }
`;

const OrderNotes = ({
  serviceNoteValue,
  invoiceNoteValue,
  disabled,
  small,
  form,
  notes = [],
  intl,
}) => {
  const serviceNoteValidator = form.getFieldDecorator('serviceNote', {
    initialValue: sanitize(serviceNoteValue?.replaceAll('<br>', '\n')),
    preserve: true,
  });
  const invoiceNoteValidator = form.getFieldDecorator('invoiceNote', {
    initialValue: sanitize(invoiceNoteValue?.replaceAll('<br>', '\n')),
    preserve: true,
  });

  form.getFieldDecorator('serviceNoteChanged');
  form.getFieldDecorator('invoiceNoteChanged');

  const setServiceNoteChangeIndicator = () => {
    form.setFieldsValue({ serviceNoteChanged: true });
  };

  const setInvoiceNoteChangeIndicator = () => {
    form.setFieldsValue({ invoiceNoteChanged: true });
  };

  const checkKey = (e) => {
    const keyCode = e.keyCode || e.which;
    // Prevent switchen from input when pressing tab
    if (keyCode === 9) {
      e.preventDefault();
    }
  };

  const determineNoteText = (note) => {
    if (note.editable) {
      if (note.noteType === types.order.serviceOrderNoteType) {
        return (
          <TextAreaWrapper small={small}>
            {serviceNoteValidator(
              <Input.TextArea
                disabled={disabled}
                onChange={setServiceNoteChangeIndicator}
                onKeyDown={checkKey}
              />,
            )}
          </TextAreaWrapper>
        );
      }
      return (
        <TextAreaWrapper small={small}>
          {invoiceNoteValidator(
            <Input.TextArea disabled={disabled} onChange={setInvoiceNoteChangeIndicator} />,
          )}
        </TextAreaWrapper>
      );
    }
    return (
      <span>
        {note &&
          note.noteTexts &&
          note.noteTexts
            ?.filter(nt => nt.textLine !== null)
            .reduce((acc, curr) => `${acc}${acc ? '\n' : ''}${curr.textLine}`, '')}
      </span>
    );
  };

  return (
    <Panel
      title={
        <span>
          <FormattedMessage id='notes.TITLE' /> ({notes?.filter(n => !n.isEmptyNote).length})
        </span>
      }
    >
      {notes && notes.length ?
        <Carousel
          initialSlide={notes.findIndex(n => n.noteType === types.order.serviceOrderNoteType)}
          itemsToHighlight={notes?.map((v, i) =>
            ({ index: i, isEmptyNote: v.isEmptyNote }),
          )?.filter(n => !n.isEmptyNote)}
        >
          {notes?.map(note =>
            <Fragment key={note.id}>
              <Flex marginBottom={5}>
                <NoteTitle>
                  <NoteName>
                    {intl.formatMessage({
                      id: note.noteType ? `notes.${note.noteType.toUpperCase()}` : 'notes.NULL',
                    })}
                  </NoteName>
                </NoteTitle>
              </Flex>
              <NoteText small={small}>{determineNoteText(note)}</NoteText>
            </Fragment>,
          )}
        </Carousel>
        :
        <FormattedMessage id='notes.NO_ORDER' />
      }
    </Panel>
  );
};
OrderNotes.propTypes = {
  small: PropTypes.bool,
  notes: PropTypes.array,
  serviceNoteValue: PropTypes.string,
  invoiceNoteValue: PropTypes.string,
  intl: PropTypes.object,
  form: PropTypes.object,
  disabled: PropTypes.bool,
};


export default injectIntl(OrderNotes);
